import { Card, CardContent } from '@/components/ui/card';
import { LucideIcon, TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

interface WhoopMetricCardProps {
  icon: LucideIcon;
  label: string;
  value: string | number;
  unit?: string;
  trend?: 'up' | 'down' | 'stable';
  trendValue?: string;
  colorClass?: string;
  bgClass?: string;
  onClick?: () => void;
}

export default function WhoopMetricCard({
  icon: Icon,
  label,
  value,
  unit,
  trend,
  trendValue,
  colorClass = 'text-primary',
  bgClass = 'bg-primary/10',
  onClick
}: WhoopMetricCardProps) {
  return (
    <Card 
      className={cn(
        'cursor-pointer hover:shadow-lg transition-all duration-200 hover:scale-[1.02] overflow-hidden border-border/40',
        bgClass
      )}
      onClick={onClick}
    >
      <CardContent className="p-4 sm:p-5">
        <div className="flex flex-col items-center text-center gap-2.5">
          <div className={cn('p-2.5 rounded-full', bgClass)}>
            <Icon className={cn('h-5 w-5 sm:h-6 sm:w-6', colorClass)} />
          </div>
          <div className="w-full min-w-0">
            <p className="text-xs sm:text-sm text-foreground/70 font-medium truncate leading-tight uppercase tracking-wide">{label}</p>
            <div className="flex items-baseline justify-center gap-1 mt-1.5">
              <span className={cn('text-2xl sm:text-3xl font-bold truncate tracking-tight', colorClass)}>
                {value}
              </span>
              {unit && <span className="text-sm font-medium text-foreground/60">{unit}</span>}
            </div>
          </div>
          
          {trend && (
            <div className="flex items-center gap-1.5 text-xs sm:text-sm font-medium">
              {trend === 'up' && <TrendingUp className="h-4 w-4 text-accent" />}
              {trend === 'down' && <TrendingDown className="h-4 w-4 text-secondary" />}
              {trend === 'stable' && <Minus className="h-4 w-4 text-muted-foreground" />}
              {trendValue && <span className="text-foreground/70">{trendValue}</span>}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
